import { ChangeDetectorRef, Component, Input, OnChanges } from '@angular/core';

import { ListPublishingState } from '..';

@Component({
  selector: 'rl-list-saving-status',
  templateUrl: './list-saving-status.component.html',
  styleUrls: ['./list-saving-status.component.scss'],
})
export class ListSavingStatusComponent implements OnChanges {
  constructor(private cd: ChangeDetectorRef) {}

  @Input() listPublishingStatus: ListPublishingState;
  @Input() queueSize: number;

  isSaving = false;
  isSaved = false;

  ngOnChanges(): void {
    const isSaving =
      this.queueSize > 0 &&
      this.listPublishingStatus !== ListPublishingState.PUBLISH_ACTIONED &&
      this.listPublishingStatus !==
        ListPublishingState.PUBLISH_ACTION_PERSISTED;

    const isSaved =
      this.queueSize === 0 &&
      this.listPublishingStatus !==
        ListPublishingState.PUBLISH_ACTION_SUCCEEDED;

    // We have to add an artificial delay otherwise the save happens so quickly that
    // the user won't appreciate the "Saving..." / "Saved" state change and it will
    // always look like it's "Saved".
    const timeout = isSaved ? 1000 : 0;
    setTimeout(() => {
      this.isSaving = isSaving;
      this.isSaved = isSaved;
      this.cd.markForCheck();
    }, timeout);
  }
}
